import { toast } from "sonner";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import { FaArrowRotateLeft } from "react-icons/fa6";
import LoadingSpinner from "../../Components/spinner";
import { handleErrors, stringToColor } from "../../services/dataManager";
import { Button, Table, Modal, Form } from "react-bootstrap";
import {
  applyBannerFilters,
  deleteBanner,
  restoreBannerById,
  toggleBannerStatus,
} from "../../services/axios/apiManager";

const HomeBannerList = ({ banners, setBanners, getData }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);

  // // // Delete banner
  const handleDelete = (item) => {
    setModalOptions({
      header: "Delete Section",
      body: `Are you sure you want to delete section "${item.heading}"?`,
      okay: "Delete",
      method: deleteSection,
      data: { id: item.id },
    });
    setShowOptionsModal(true);
  };

  const deleteSection = async (data) => {
    setLoading(true);
    const res = await deleteBanner(data.id);
    if (res?.data?.success) {
      await getData();
      toast.info(
        res?.data?.message || "Section has been deleted successfuly.",
        { duration: 3000 },
      );
      handleCloseOptionsModal();
    } else {
      handleErrors(res, null, "Home Page:");
    }
    setLoading(false);
  };

  // // // Change banner Status
  const handleStatus = (item) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change status of "${item.heading}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: item.id, status: item.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    setLoading(true);
    const res = await toggleBannerStatus(data);
    if (res?.data?.success) {
      await getData();
      toast.info(
        res?.data?.message || "Banner status has been updated successfuly.",
        { duration: 3000 },
      );
      handleCloseOptionsModal();
    } else {
      handleErrors(res, null, "Home Banners:");
    }
    setLoading(false);
  };

  // // // Restore deleted banner
  const handleRestoreSection = (item) => {
    setModalOptions({
      header: "Restore Section",
      body: `Are you sure you want to restore "${item.heading}"?`,
      okay: "Restore",
      method: restorePageSection,
      data: { id: item.id },
    });
    setShowOptionsModal(true);
  };

  const restorePageSection = async (data) => {
    setLoading(true);
    const res = await restoreBannerById(data.id);
    if (res?.data?.success) {
      if (query || status) {
        await handleApplyFilters(query, status);
      } else {
        await getData();
      }
      toast.info(
        res?.data?.message || "Banner has been restored successfuly.",
        { duration: 3000 },
      );
      handleCloseOptionsModal();
    } else {
      handleErrors(res, navigate, "Restore Page Section: ");
    }
    setLoading(false);
  };

  const handleCloseOptionsModal = () => {
    setShowOptionsModal(false);
    setModalOptions({});
  };

  // // // Applying all filters
  const handleApplyFilters = async (bnrQuery, bnrStatus) => {
    // // // keep sequence exactly as follows query, status and then section type
    const res = await applyBannerFilters(bnrStatus, bnrQuery);
    if (res?.data?.success) {
      setBanners(res?.data?.data);
    } else {
      handleErrors(res, navigate, "Home Banner: ");
    }
  };

  // // // Reset filters and fetch data again
  const resetFilters = async () => {
    setLoading(true);
    setQuery("");
    setStatus("");
    await getData();
    setLoading(false);
  };

  return (
    <div className="bg-dark p-4 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="row col-md-12">
          <div className="col-xs-12 col-md-3">
            <Form.Control
              type="text"
              placeholder="serach..."
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                handleApplyFilters(e.target.value, status);
              }}
            />
          </div>
          <div className="col-xs-12 col-md-3">
            <Form.Select
              className={status === "deleted" ? "text-danger" : "text-light"}
              name="status"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                handleApplyFilters(query, e.target.value);
              }}
            >
              <option className="text-light" value="3">
                Active & In-Active
              </option>
              <option className="text-light" value="1">
                Active
              </option>
              <option className="text-light" value="0">
                In-Active
              </option>
              <option className="text-danger" value="2">
                Deleted
              </option>
            </Form.Select>
          </div>
          <div className="col-xs-12 col-md-1">
            <div className="row">
              <Button
                title="Reset Filters And Rrfresh Records"
                className="btn btn-success"
                disabled={loading}
                onClick={() => {
                  resetFilters();
                }}
              >
                {loading ? (
                  <LoadingSpinner size={"sm"} variant={"light"} />
                ) : (
                  "Reset"
                )}
              </Button>
            </div>
          </div>
          <div className="col-xs-12 col-md-5">
            <div className="d-flex justify-content-end gap-2">
              <Button
                title="Review all sections"
                className="btn btn-success"
                onClick={() => {
                  navigate("/review-home-banner");
                }}
              >
                Review Banners
              </Button>
              <Button
                title="Add New Section"
                className="btn btn-success"
                onClick={() => {navigate(`/add-edit-home-banner`)}}
              >
                Add Banner
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive mt-4">
        <Table striped hover variant="dark" className="mt-4">
          <thead>
            <tr>
              <th>Heading</th>
              <th>Banner Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {banners?.length > 0 &&
              banners.map((banner, index) => (
                <tr key={index}>
                  <td>{banner?.heading}</td>
                  <td
                    style={{
                      color: banner?.banner_type
                        ? stringToColor(banner?.banner_type)
                        : "#fff",
                    }}
                  >
                    {banner?.banner_type}
                  </td>

                  <td>
                    <button
                      title="change section status"
                      className={`btn btn-link p-0 m-0 border-0 ${
                        banner?.status ? "text-success" : "text-danger"
                      }`}
                      onClick={() => {
                        handleStatus(banner);
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      {banner?.status === 1 ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td className="w-40">
                    <Button
                      title="Review section"
                      variant="outline-success"
                      size="sm"
                      onClick={() => {
                        navigate(`/review-home-banner/${banner.id}`);
                      }}
                    >
                      <FaEye />
                    </Button>
                    <Button
                      title="edit section"
                      variant="outline-primary"
                      className="ml-1 mr-1"
                      size="sm"
                      onClick={() => {
                        navigate(`/add-edit-home-banner/${banner.id}`);
                      }}
                    >
                      <FaEdit />
                    </Button>
                    {banner?.status === 0 && banner?.deletedAt === null && (
                      <Button
                        title="delete section"
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          handleDelete(banner);
                        }}
                      >
                        <FaTrashAlt />
                      </Button>
                    )}
                    {banner?.deletedAt && (
                      <Button
                        title="Restore Section"
                        variant="outline-info"
                        size="sm"
                        onClick={() => {
                          handleRestoreSection(banner);
                        }}
                      >
                        <FaArrowRotateLeft />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          {loading && <LoadingSpinner size={"lg"} variant={"light"} />}
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HomeBannerList;
